export default "__VITE_ASSET__I5Cf10S4__"